import React from 'react'
import { Typography } from "@mui/material";

/**
 * ページタイトルを表示する
 */
export function Title({children}: {children: React.ReactNode}) {
    return(
        <>
            <Typography
                variant='h5'
                sx={{
                    textAlign:"left",
                    mt:1
                }}
            >
                {children}
            </Typography>  
        </>
    );
}